import { oc } from '@orpc/contract';
import { validatePolicyDraftInputSchema, validatePolicyDraftOutputSchema } from '../schemas/policies.schemas.js';
/**
 * Compiles a set of equations and answers with every problem found — nothing is written. The browser
 * runs the same compiler locally on every keystroke; this is the authoritative second opinion the
 * administrator must obtain before publishing (PP AC23).
 */
export const validatePolicyDraftContract = oc
    .route({
    method: 'POST',
    path: '/policies/validate',
    tags: ['Policies'],
    summary: 'Check a set of equations without saving them',
})
    .input(validatePolicyDraftInputSchema)
    .output(validatePolicyDraftOutputSchema);
//# sourceMappingURL=validate-policy-draft.contract.js.map